import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import types from '../mutation-types';
import CadenciaAPI from '../../api/cadencias';
import { throwErrorMessage } from '../utils/api';

export const state = {
  records: [],
  uiFlags: {
    isFetchingItem: false,
    isFetching: false,
    isCreating: false,
    isDeleting: false,
    isUpdating: false,
  },
};

export const getters = {
  getCadencias($state) {
    return $state.records;
  },
  getCadencia: $state => id => {
    return $state.records.find(record => record.id === Number(id));
  },
  getUIFlags($state) {
    return $state.uiFlags;
  },
};

export const actions = {
  get: async function getCadencias({ commit }) {
    commit(types.SET_CADENCIAS_UI_FLAG, { isFetching: true });
    try {
      const response = await CadenciaAPI.get();
      commit(types.SET_CADENCIAS, response.data.payload?.cadencias || []);
    } catch (error) {
      // Ignore error
    } finally {
      commit(types.SET_CADENCIAS_UI_FLAG, { isFetching: false });
    }
  },
  getSingleCadencia: async function getCadenciaById({ commit }, cadenciaId) {
    commit(types.SET_CADENCIAS_UI_FLAG, { isFetchingItem: true });
    try {
      const response = await CadenciaAPI.show(cadenciaId);
      commit(types.ADD_CADENCIA, response.data.payload?.cadencia || null);
    } catch (error) {
      // Ignore error
    } finally {
      commit(types.SET_CADENCIAS_UI_FLAG, { isFetchingItem: false });
    }
  },
  create: async function createCadencia({ commit }, cadenciaObj) {
    commit(types.SET_CADENCIAS_UI_FLAG, { isCreating: true });
    try {
      const response = await CadenciaAPI.create(cadenciaObj);
      commit(types.ADD_CADENCIA, response.data.payload?.cadencia || null);
    } catch (error) {
      throwErrorMessage(error);
    } finally {
      commit(types.SET_CADENCIAS_UI_FLAG, { isCreating: false });
    }
  },
  update: async ({ commit }, { id, ...updateObj }) => {
    commit(types.SET_CADENCIAS_UI_FLAG, { isUpdating: true });
    try {
      const response = await CadenciaAPI.update(id, updateObj);
      commit(types.EDIT_CADENCIA, response.data.payload?.cadencia || null);
    } catch (error) {
      throwErrorMessage(error);
    } finally {
      commit(types.SET_CADENCIAS_UI_FLAG, { isUpdating: false });
    }
  },
  delete: async ({ commit }, id) => {
    commit(types.SET_CADENCIAS_UI_FLAG, { isDeleting: true });
    try {
      await CadenciaAPI.delete(id);
      commit(types.DELETE_CADENCIA, id);
    } catch (error) {
      throwErrorMessage(error);
    } finally {
      commit(types.SET_CADENCIAS_UI_FLAG, { isDeleting: false });
    }
  },
};

export const mutations = {
  [types.SET_CADENCIAS_UI_FLAG]($state, data) {
    $state.uiFlags = {
      ...$state.uiFlags,
      ...data,
    };
  },
  [types.ADD_CADENCIA]: MutationHelpers.setSingleRecord,
  [types.SET_CADENCIAS]: MutationHelpers.set,
  [types.EDIT_CADENCIA]: MutationHelpers.update,
  [types.DELETE_CADENCIA]: MutationHelpers.destroy,
};

export default {
  namespaced: true,
  actions,
  state,
  getters,
  mutations,
};
